import {HttpLink} from '@apollo/client';
import {graphAPIPath} from 'js/tool/APIProvider';
import {getClient} from 'js/tool/graphql/client/apollo/tool';

export default getClient(new HttpLink({uri: graphAPIPath}));
